import React from 'react';
import styles from './Tabs.module.scss';
import Tab from './Tab';
import { TabsProps } from './types';

const Tabs = (props: TabsProps) => {
  const {
    tabs,
    labels = {},
    selectedTab,
    setSelectedTab,
    vertical = false,
    onSelect = () => null
  } = props;

  return (
    <div
      className={vertical ? styles.containerVertical : styles.container}
    >
      {tabs.map((tab, index) =>
        <Tab
          key={index}
          text={tab}
          label={labels[tab]}
          selected={selectedTab === tab}
          onClick={() => {
            setSelectedTab(tab);
            onSelect();
          }}
          vertical={vertical}
        />
      )}
    </div>
  );
};

export default Tabs;
